module.exports = __webpack_public_path__ + "images/addMinor_2c6963c.svg";